// extracted by mini-css-extract-plugin
module.exports = {"container":"BlogLayout_container__1fiRb","title":"BlogLayout_title__3HyDU","header":"BlogLayout_header__2Aht3","rightSideLink":"BlogLayout_rightSideLink__1uv97"};